angular.module('unergie.main')
.filter('numberFormat', () =>
    _.memoize((val) => {
        return Number(val).toLocaleString('fr-FR')
    })
)
